// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + "integrated-debug-modal" + "-03f6d7a.js";
};